import React, { useEffect, useState } from "react";
import type { PackageSelectorProps } from "../../../type/packages";
import { getUser, isAuthenticated } from "../../../auth/auth";
import type { UserModel } from "../../../type/user";
import { PackageIcon } from "../../../components/packageIcon/packageIcon";
import type { PackageType } from "../../../type/package";
import "./packageSelector.scss";

const PackageSelector: React.FC<PackageSelectorProps> = ({
  packages,
  selectedPackageId,
  onSelect,
}) => {
  const [user, setUser] = useState<UserModel | null>(null); 

  useEffect(() => {
    if (isAuthenticated()) {
      const userData = getUser();
      setUser(userData);
    }
  }, []);

  const isAdmin = user?.admin === true;

  const handleSelect = (pkg: typeof packages[0]) => {
    if (!isAdmin) {
      return; // Block selection for non-admin users
    }
    onSelect(pkg);
  };

  return (
    <div className="package-selector">
      {packages.map(pkg => (
        <div
          key={pkg.id}
          className={`package-card package-${pkg.name.toLowerCase()} ${
            selectedPackageId === pkg.id ? "selected" : ""
          } ${!isAdmin ? "disabled" : ""} ${
            selectedPackageId === pkg.id ? "package-currently-selected" : ""
          }`}
        >
          <div className="icon-wrapper">
            <PackageIcon
              type={pkg.name.toLowerCase() as PackageType}
            />
          </div>

          <h3 className="title">{pkg.name}</h3>

          <div className="data">
            {pkg.dictionaries} dictionaries<br />
            {pkg.expressions} expressions
          </div>

          {/* {pkg.price_regular !== null && (
            <div className="price">
              <span className="label">Price: </span>
              <strong>{pkg.price_regular} PLN / month</strong>
            </div>
          )} */}

          {pkg.price_promo !== null && (
            <div className="promo">Promo: {pkg.price_promo}</div>
          )}

          <button
            className={`select-btn ${!isAdmin ? "disabled" : ""}`}
            onClick={() => handleSelect(pkg)}
            disabled={!isAdmin || selectedPackageId === pkg.id}
            title={!isAdmin ? "Only administrators can change packages" : ""}
          >
            {!isAdmin ? "Admin Only" : (selectedPackageId === pkg.id ? "Current" : "Select")}
          </button>
        </div>
      ))}
    </div>
  );
};

export default PackageSelector;
